import './journeyCalendar.css'
import { Icon } from '../Icon'
import { scheduleToday } from '../../domain/scheduling'

export function JourneyCalendar({ month, selectedDate, days, state, onRetry, onMonthChange, onSelect, description, mode = 'availability', minDate, maxDate }: {
  mode?: 'availability' | 'date-filter'
  minDate?: string
  maxDate?: string
  description?: string
  month: string
  selectedDate: string | null
  days: { date: string; hasCompleteJourney: boolean; journeyCount?: number }[]
  state: 'idle' | 'loading' | 'error' | 'ready'
  onRetry: () => void
  onMonthChange: (month: string) => void
  onSelect: (date: string) => void
}) {
  const [year, monthNumber] = month.split('-').map(Number)
  const today = scheduleToday()
  const busy = state === 'loading'
  const changeMonth = (offset: number) => {
    const next = new Date(year, monthNumber - 1 + offset, 1)
    onMonthChange(`${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, '0')}`)
  }
  return <section className="fz-jagenda-calendar" aria-label="Calendário da jornada" aria-busy={busy}>
    <div className="fz-jagenda-calendar-head">
      <button type="button" className="fz-iconbtn" aria-label="Mês anterior" disabled={busy || (mode === 'availability' && month <= today.slice(0, 7))} onClick={() => changeMonth(-1)}><Icon name="arrowLeft" size={16} /></button>
      <strong>{new Date(year, monthNumber - 1, 1).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}</strong>
      <button type="button" className="fz-iconbtn" aria-label="Próximo mês" disabled={busy} onClick={() => changeMonth(1)}><Icon name="arrowR" size={16} /></button>
    </div>
    <div className="fz-jagenda-days">
      {['D', 'S', 'T', 'Q', 'Q', 'S', 'S'].map((day, index) => <span key={index}>{day}</span>)}
      {Array.from({ length: new Date(year, monthNumber - 1, 1).getDay() }, (_, index) => <span key={`blank${index}`} />)}
      {Array.from({ length: new Date(year, monthNumber, 0).getDate() }, (_, index) => {
        const date = `${month}-${String(index + 1).padStart(2, '0')}`
        const availability = state === 'ready' ? days.find((day) => day.date === date) : undefined
        if (mode === 'date-filter') {
          const count = availability?.journeyCount ?? 0
          const disabled = !!((minDate && date < minDate) || (maxDate && date > maxDate))
          return <button type="button" key={date} disabled={disabled}
            aria-label={`${date}, ${count ? `${count} jornada${count > 1 ? 's' : ''} agendada${count > 1 ? 's' : ''}` : 'selecionar dia'}`}
            aria-current={date === today ? 'date' : undefined} aria-pressed={selectedDate === date}
            className={'fz-datefilter-day' + (count ? ' has-journeys' : '') + (selectedDate === date ? ' is-selected' : '')} onClick={() => onSelect(date)}>
            <span>{index + 1}</span>{count > 0 && <small aria-hidden="true">{count > 99 ? '99+' : count}</small>}
          </button>
        }
        const past = date < today
        const available = !past && availability?.hasCompleteJourney === true
        const unavailable = !past && availability?.hasCompleteJourney === false
        const label = past ? 'data passada' : available ? 'jornada disponível' : unavailable ? 'sem sequência completa'  : busy ? 'consultando disponibilidade' : 'disponibilidade não consultada'
        return <button type="button" key={date} disabled={!available} aria-label={`${date}, ${label}`} aria-pressed={available && selectedDate === date} className={(available ? 'has-slots' : unavailable ? 'is-full' : 'is-unknown') + (available && selectedDate === date ? ' is-active' : '')} onClick={() => onSelect(date)}>{index + 1}</button>
      })}
    </div>
    {state === 'ready' && mode === 'availability' && <div className="fz-jagenda-calendar-legend"><span><i className="green" />Todos os serviços disponíveis neste dia</span><span><i className="red" />Sem disponibilidade para toda a jornada</span></div>}
    {mode === 'date-filter' && <p className="fz-jagenda-muted" role="status">{busy ? 'Consultando jornadas do mês…' : state === 'error' ? 'Não foi possível consultar os dias com jornadas.' : 'Números indicam jornadas agendadas nos dias.'}</p>}
    {mode === 'availability' && <p className="fz-jagenda-muted" role="status">{busy ? 'Carregando dias disponíveis…' : state === 'error' ? 'Não foi possível consultar os dias. Tente novamente.' : state === 'idle' ? 'Disponibilidade ainda não consultada.' : description ?? 'Escolha um dia com todos os serviços disponíveis. A compatibilidade dos horários é conferida na próxima etapa.'}</p>}
    {state === 'error' && <button type="button" className="fz-jagenda-text" onClick={onRetry}>Tentar novamente</button>}
  </section>
}
